import { createContext, useContext, useEffect, useState } from 'react';
import Loader from '../Componant/Loader/Loader';
import { useLocation } from 'react-router-dom';
import { my_jobs_list } from '../Services/Student/StudentApi';
import { mapApiFilterToSelectedFilters } from '../utils/dashboardFilters';

export const AuthContext = createContext();
export const LoaderContext = createContext();

const AuthProvider = ({ children }) => {
  const [authDetails, setAuthDetails] = useState(() => {
    const saved = localStorage.getItem('login');
    return saved ? JSON.parse(saved) : null;
  });
  const userId = authDetails?.student?.id || authDetails?.seeker?.id || authDetails?.admin?.id || null;
  const [currentPage, setCurrentPage] = useState(1);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownMobile, setShowDropdownMobile] = useState(false);
  const [ShowNextPage, setShowNextPage] = useState(false);
  const [Tab, setTab] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [jobs, setJobs] = useState([]); // State to hold recommended jobs
  const [savedCount, setSavedCount] = useState(0);
  const [appliedCount, setAppliedCount] = useState(0);
  const [selectedJob, setSelectedJob] = useState(null); // State to hold the selected job
  const [activeTab, setActiveTab] = useState(null);
  const storedLogin = JSON.parse(localStorage.getItem('login'));
  const [userRole, setUserRole] = useState(storedLogin?.role || '');
  const [isLoggedIn, setIsLoggedIn] = useState(!!authDetails);
  const [listCount, setListCount] = useState(0);
  const [isProfileUpdate, setIsProfileUpdate] = useState(false);
  const [jobFeedRefreshRequest, setJobFeedRefreshRequest] = useState(0);
  const [isMobileRecords, setIsMobileRecords] = useState(1);
  const [resumeCredit, setResumeCredit] = useState(null);
  const [studentProfile, setStudentProfile] = useState(null);
  const [desktopRecords, setDesktopRecords] = useState(1);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    jobType: [],
    location: {
      withinUS: true,
      cityState: [],
      miles: '25 mi',
    },
    datePosted: [],
    jobTitles: [],
    companyName: '',
    experienceLevels: [],
    workModel: [],
    salaryRanges: [],
    workAuthorization: false,
    selectedCity: [],
    selectedState: [],
    _query: '',
  });
  useEffect(() => {
    // Sync isLoggedIn whenever authDetails changes
    setIsLoggedIn(!!authDetails);
  }, [authDetails]);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      if (width <= 768) {
        setIsMobile(true);
      } else if (width > 768) {
        setIsMobile(false);
      }
      // Set isMobile based on width
      if (height <= 360) {
        setDesktopRecords(1);
        setIsMobileRecords(1);
      } else if (height >= 361 && height <= 400) {
        setDesktopRecords(2);
        setIsMobileRecords(2);
      } else if (height >= 401 && height <= 440) {
        setDesktopRecords(3);
        setIsMobileRecords(3);
      } else if (height >= 440 && height <= 520) {
        // Adjusted this condition to properly capture heights >= 841
        setDesktopRecords(4);
        setIsMobileRecords(4);
      } else if (height >= 521 && height <= 600) {
        setDesktopRecords(5);
        setIsMobileRecords(5);
      } else if (height >= 601 && height <= 660) {
        setDesktopRecords(6);
        setIsMobileRecords(6);
      } else if (height >= 661 && height <= 700) {
        setDesktopRecords(7);
        setIsMobileRecords(7);
      } else if (height >= 701 && height <= 740) {
        setDesktopRecords(8);
        setIsMobileRecords(8);
      } else if (height >= 741 && height <= 780) {
        setDesktopRecords(9);
        setIsMobileRecords(9);
      } else if (height >= 781 && height <= 820) {
        setDesktopRecords(9);
        setIsMobileRecords(9);
      } else if (height >= 801 && height <= 840) {
        setDesktopRecords(10);
        setIsMobileRecords(10);
      } else if (height >= 840) {
        setDesktopRecords(15);
        setIsMobileRecords(15);
      } else {
        setDesktopRecords(6);
        setIsMobileRecords(10);
      }
    };
    handleResize(); // Set initial viewport size
    window.addEventListener('resize', handleResize); // Listen for viewport changes
    return () => window.removeEventListener('resize', handleResize); // Clean up on unmount
  }, []);

  // login set function
  const setLoginItem = logInItem => {
    setAuthDetails(logInItem);

    if (!logInItem) {
      localStorage.removeItem('login');
      setUserRole(null);
      return;
    }

    localStorage.setItem('login', JSON.stringify(logInItem));
    const storedLogin = JSON.parse(localStorage.getItem('login'));
    if (storedLogin && storedLogin.role === undefined) {
      localStorage.clear();
    }
    localStorage.setItem('login', JSON.stringify(logInItem));
    setUserRole(storedLogin?.role);
  };

  // Simple hash-based color generator
  function getColorForKey(key, index) {
    const customColors = ['#1F7630', '#47BE7D', '#3E97FF', '#E88931', '#275FA5'];

    return customColors[index % customColors.length];
  }

  const convertToCSV = data => {
    const headers = Object.keys(data[0]).join(',');
    const escapeValue = val => `"${String(val).replace(/"/g, '""')}"`; // Escape double quotes

    const rows = data.map(row => Object.values(row).map(escapeValue).join(','));

    return [headers, ...rows].join('\n');
  };

  const downloadCSV = (data, fileName) => {
    const csv = convertToCSV(data);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const calculatePageSize = () => {
    const rowHeight = 80; // Approximate row/card height in pixels
    const paddingOffset = 200; // Header, footer, and padding
    const visibleHeight = window.innerHeight - paddingOffset;
    const items = Math.floor(visibleHeight / rowHeight);
    return Math.max(items, 15); // Ensure a minimum of 5 items
  };

  const fetchJobByFilterCounts = async (searchParam, currentPageSize) => {
    try {
      let filterPayload = {};

      if (selectedFilters.jobTitles?.length > 0) {
        filterPayload.jobTitle = selectedFilters.jobTitles;
      }

      if (selectedFilters.companyName?.trim()) {
        filterPayload.companyName = selectedFilters.companyName.trim();
      }

      if (selectedFilters.jobType?.length > 0) {
        filterPayload.jobTypes = selectedFilters.jobType;
      }

      if (selectedFilters.experienceLevels?.length > 0) {
        filterPayload.experienceLevels = selectedFilters.experienceLevels;
      }

      const datePostedMap = {
        'Past 24 hours': 'past_24_hours',
        'Past 3 days': 'past_3_days',
        'Past 7 days': 'past_week',
        'Past 30 days': 'past_month',
        'Past week': 'past_week',
        'Past month': 'past_month',
      };

      if (selectedFilters.datePosted?.length > 0) {
        const firstSelectedLabel = selectedFilters.datePosted[0];
        const mappedValue = datePostedMap[firstSelectedLabel];
        if (mappedValue) {
          filterPayload.datePosted = mappedValue;
        }
      }

      if (selectedFilters.workAuthorization) {
        filterPayload.workAuthorization = selectedFilters.workAuthorization;
      }

      if (selectedFilters.salaryRanges?.length > 0) {
        filterPayload.compensation = {
          minimumAnnualSalary: Number(selectedFilters.salaryRanges[0]),
        };
      }

      const cities = (selectedFilters.selectedCity || []).map(item => {
        if (item.includes('(') && item.includes(')')) {
          const code = item.match(/\(([^)]+)\)/)?.[1];
          return code || item;
        }
        return item;
      });

      // Extract state codes from selectedState
      const states = (selectedFilters.selectedState || []).map(item => {
        if (item.includes('(') && item.includes(')')) {
          const code = item.match(/\(([^)]+)\)/)?.[1];
          return code || item;
        }
        return item;
      });

      // Handle workModel → cities logic
      const workModelArray = selectedFilters.workModel || [];
      const includesRemote = workModelArray.includes('Remote');
      const includesOnSite = workModelArray.includes('On-Site');
      if (includesRemote) {
        cities.push('remote');
      }
      if (includesOnSite) {
        cities.push('onsite');
      }

      if (cities.length > 0 || states.length > 0 || selectedFilters.location.withinUS !== undefined) {
        filterPayload.location = {};

        if (cities.length > 0) {
          filterPayload.location.cities = cities;
        }

        if (states.length > 0) {
          filterPayload.location.states = states;
        }

        // Add radius if it exists
        if (selectedFilters.location?.radius && selectedFilters.location?.radiusTouched) {
          filterPayload.location.radius = selectedFilters.location.radius;
        }
      }

      // Clean up location object if empty
      if (
        filterPayload.location &&
        !filterPayload.location.cities &&
        !filterPayload.location.states &&
        filterPayload.location.withinUS === undefined
      ) {
        delete filterPayload.location;
      }

      // Optional: Clean up if empty
      if (Object.keys(filterPayload).length === 0) {
        filterPayload = undefined;
      }

      const recommendedResponse = await my_jobs_list({
        filters: filterPayload,
        query: searchParam ?? searchTerm,
        page: currentPageSize || currentPage,
      });

      return recommendedResponse;
    } catch (err) {
      console.error('Error fetching job counts:', err);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        userId,
        showDropdownMobile,
        setShowDropdownMobile,
        setShowNextPage,
        ShowNextPage,
        listCount,
        setListCount,
        isMobileRecords,
        desktopRecords,
        isMobile,
        showDropdown,
        setShowDropdown,
        currentPage,
        setCurrentPage,
        Tab,
        setTab,
        searchTerm,
        setSearchTerm,
        mapApiFilterToSelectedFilters,
        fetchJobByFilterCounts,
        jobs,
        setJobs,
        savedCount,
        setSavedCount,
        selectedJob,
        setSelectedJob,
        appliedCount,
        setAppliedCount,
        setSelectedFilters,
        selectedFilters,
        calculatePageSize,
        downloadCSV,
        convertToCSV,
        authDetails,
        setLoginItem,
        isLoggedIn,
        getColorForKey,
        userRole,
        setUserRole,
        setIsProfileUpdate,
        isProfileUpdate,
        jobFeedRefreshRequest,
        setJobFeedRefreshRequest,
        activeTab,
        setActiveTab,
        setAuthDetails,
        resumeCredit,
        setResumeCredit,
        studentProfile,
        setStudentProfile,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const LoaderProvider = ({ children }) => {
  const [loader, setLoader] = useState(false);
  const [insideLoader, setInsiderLoader] = useState(false);
  const [Dashboardloader, setDashboardLoader] = useState(false);
  const [JobListloader, setJobListLoader] = useState(false);
  const [Studentloader, setStudentLoader] = useState(false);
  const [StudentManageloader, setStudentManageLoader] = useState(false);
  const [StudentDetailsloader, setStudentDetailsLoader] = useState(false);
  const [StudentDashboardloader, setStudentDashboardLoader] = useState(false);
  const location = useLocation();
  const showLoader = loader;
  return (
    <LoaderContext.Provider
      value={{
        setStudentDashboardLoader,

        StudentDashboardloader,
        StudentDetailsloader,
        setStudentDetailsLoader,
        StudentManageloader,
        setStudentManageLoader,
        loader,
        setLoader,
        setInsiderLoader,
        insideLoader,
        Dashboardloader,
        setDashboardLoader,
        JobListloader,
        setJobListLoader,
        Studentloader,
        setStudentLoader,
      }}
    >
      {children}
      {showLoader && <Loader />}
    </LoaderContext.Provider>
  );
};

export { LoaderProvider };
export default AuthProvider;
